import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import get from 'lodash/get';

import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

import ArticlePreview from '../articles/ArticlePreview.jsx';

import { env } from '../../../config';

const PageAssignment = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `/api/quiz/assignments/${_id}`,
    });
  }, []);

  return (
    <PageHttp res={res}>
      {(doc) => (
        <ArticlePreview article={doc.article}>
          <Header
            breadcrumb={[
              { to: '../', children: 'Assignments' },
            ]}
          >
            <>
              {moment(doc.date).format('YYYY-MM-DD')}
              &nbsp;
              ({get(env.lvs, `${doc.lv}.zhhk`)})
            </>
          </Header>
        </ArticlePreview>
      )}
    </PageHttp>
  );
};

export default PageAssignment;
